export default __webpack_public_path__ + "static/media/avatar-man.86031376.svg";